/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var About = (function (_Component) {
	_inherits(About, _Component);

	function About() {
		_classCallCheck(this, About);

		_Component.apply(this, arguments);

		this.state = {};
	}

	About.prototype.render = function render() {
		var _classNames;

		var styles = require('./Contact.css');
		var contentStyles = _classnames2['default']((_classNames = {}, _classNames[styles.Content] = true, _classNames.CMSContent = true, _classNames));

		return _react2['default'].createElement(
			'main',
			{ className: styles.Base },
			_react2['default'].createElement(_reactHelmet2['default'], { title: 'Contact Us | Baltimore Brew' }),
			_react2['default'].createElement(
				'article',
				{ className: styles.Article },
				_react2['default'].createElement(
					'header',
					{ className: styles.Header },
					_react2['default'].createElement(
						'h1',
						null,
						'Contact Us'
					)
				),
				_react2['default'].createElement(
					'div',
					{ className: contentStyles },
					_react2['default'].createElement(
						'h3',
						{ className: 'h3--withBorder' },
						_react2['default'].createElement(
							'u',
							null,
							'To reach the editors of Baltimore Brew:'
						)
					),
					_react2['default'].createElement(
						'p',
						{ className: styles.P },
						'Email us at ',
						_react2['default'].createElement(
							'strong',
							null,
							_react2['default'].createElement(
								'a',
								{ href: 'mailto:editors@baltimorebrew.com' },
								'editors@baltimorebrew.com'
							)
						)
					),
					_react2['default'].createElement(
						'p',
						{ className: styles.P },
						'Or call ',
						_react2['default'].createElement(
							'strong',
							null,
							'410-802-4990'
						)
					)
				)
			)
		);
	};

	_createClass(About, null, [{
		key: 'propTypes',
		value: {},
		enumerable: true
	}]);

	return About;
})(_react.Component);

exports['default'] = About;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Contact/Contact.js
 ** module id = 700
 ** module chunks = 0
 **/